import React, { useState, useEffect, useCallback  } from "react"
import { FaWhatsapp } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";

export function WebchatButton() {
    const popupCenter = useCallback((url, title, w, h) => {
        // Fix dual-screen position (multi-monitor)
        const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : window.screenY;

        const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        window.screen.width;

        const height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        window.screen.height;

        const left = width / 2 - w / 2 + dualScreenLeft;
        const top = height / 2 - h / 2 + dualScreenTop;

        const newWindow = window.open(
        url,
        title,
        `scrollbars=yes,width=${w},height=${h},top=${top},left=${left}`
        );

        if (newWindow && window.focus) newWindow.focus();
    }, []);

    return (
        <div className="fabs">
        <button
            id="brdcstr_btn_chat"
            className="btn-wsp"
            type="button"
            onClick={() => popupCenter("https://www.conceptomovil.com/chatweb/pasivos/pasivos.html", "Webchat-Bot", 420, 740)}
            aria-label="Abrir chat"
        >
            <BiSupport className="mt--10"/>
        </button>

         {/* <a href="https://api.whatsapp.com/send?phone=5540528188" class="btn-wsp" target="_blank">
                <i class="fab fa-whatsapp"></i>
            </a> */}

        </div>
    );
}

export default WebchatButton